(function (w, $, _) {
    
    'use strict';

    const assetId = '~/Parts/Views/File/FileList/FileList.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (let ctx of w.umwAssets[assetId]) {

        const $mainPanel = $('#' + ctx.mainPanelId);
        const allFiles = ctx.files;

        // Selectors
        const filesSourceSelector = '.js-uc200-source';
        const sourceItemsContainerSelector = '.js-uc200-source-body';
        const fileItemSelector = '.js-uc200-item';
        const filterInputSelector = '.js-uc200-search';
        const noMatchesLabelSelector = '.js-uc200-no-matches';
        const sortingControlSelector = '.js-uc200-sorting-selector';

        let filterChangedTimeout, $allFileSources, $allFileItems, $noMatchesLabel;

        $(function() {
            $allFileSources = $mainPanel.find(filesSourceSelector);
            $allFileItems = $mainPanel.find(fileItemSelector);
            $noMatchesLabel = $mainPanel.find(noMatchesLabelSelector);

            // Setup sorting
            $mainPanel.find(sortingControlSelector).change(function() {
                const sortBy = this.value;

                $allFileSources.find(sourceItemsContainerSelector).each(function() {
                    const $sourceItemsContainer = $(this);
                    const sortedItems = $sourceItemsContainer.find(fileItemSelector).sort(function(file1, file2) {
                        const file1Id = $(file1).data('fileid');
                        const file1Details = _.find(allFiles, function(file) { return file.itemId === file1Id; });
                        const file2Id = $(file2).data('fileid');
                        const file2Details = _.find(allFiles, function(file) { return file.itemId === file2Id; });

                        var comparisonResult;
                        switch (sortBy) {
                            case '208': // Title ASC
                                comparisonResult = file1Details.title.localeCompare(file2Details.title);
                                break;
                            case '209': // Title DESC
                                comparisonResult = file2Details.title.localeCompare(file1Details.title);
                                break;
                            case '210': // Name ASC
                                comparisonResult = file1Details.name.localeCompare(file2Details.name);
                                break;
                            case '211': // Name DESC
                                comparisonResult = file2Details.name.localeCompare(file1Details.name);
                                break;
                            case '246': // Date ASC
                                comparisonResult = Date.parse(file1Details.date) - Date.parse(file2Details.date);
                                break;
                            case '247': // Date DESC
                                comparisonResult = Date.parse(file2Details.date) - Date.parse(file1Details.date);
                                break;
                            case '30009': // Size ASC
                                comparisonResult = file1Details.size - file2Details.size;
                                break;
                            case '30010': // Size DESC
                                comparisonResult = file2Details.size - file1Details.size;
                                break;
                            default: // OrderNr ASC
                                comparisonResult = file1Details.orderNr - file2Details.orderNr;
                                break;
                        }

                        return comparisonResult;
                    });

                    $sourceItemsContainer.html(sortedItems);
                });
            });

            // Setup filtering
            $mainPanel.find(filterInputSelector).on('keyup',
                function() {
                    const filterTerm = ($(this).val() || '').toLowerCase();
                    if (filterChangedTimeout) {
                        w.clearTimeout(filterChangedTimeout);
                    }

                    filterChangedTimeout = w.setTimeout(function() {
                            // Since there is no paging, just check and show/hide currently shown rows
                            $allFileItems.each(function() {
                                const $this = $(this);
                                const fileId = $this.data('fileid');
                                const fileDetails = _.find(allFiles, function(file) { return file.itemId === fileId; });

                                const title = (fileDetails.title || '').toLowerCase();
                                const name = (fileDetails.name || '').toLowerCase();
                                const description = (fileDetails.description || '').toLowerCase();

                                const isMatch = _.some(filterTerm.split(';'),
                                    function(termPart) {
                                        termPart = $.trim(termPart);
                                        return title.indexOf(termPart) > -1 ||
                                            name.indexOf(termPart) > -1 ||
                                            description.indexOf(termPart) > -1;
                                    });

                                if (isMatch) {
                                    $this.show();
                                } else {
                                    $this.hide();
                                }
                            });

                            // Hide empty sources
                            $allFileSources.each(function() {
                                const $sourceContainer = $(this);
                                const totalVisibleItems = $sourceContainer.find(fileItemSelector).filter(function() {
                                    return $(this).css('display') !== 'none';
                                }).length;
                                if (totalVisibleItems > 0) {
                                    $sourceContainer.show();
                                } else {
                                    $sourceContainer.hide();
                                }
                            });

                            // Show message if all sources are hidden
                            if (!$allFileSources.is(':visible')) {
                                $noMatchesLabel.show();
                            } else {
                                $noMatchesLabel.hide();
                            }
                        },
                        200);
                });
        });
    }
})(window, jQuery, _)